<template>
  <div class="signup-container">
  <div class="d-flex so-container">
    <div class="col-6 logo-container" :style="backgroundColor">
      <div class="big-logo hq-logo" :style="hqLogo"></div>
      <div class="step-title mt-5">
        Let's get you started
      </div>
<!--      <div class="step-desc">Create your account and get acces</div>-->
      <div class="logo-powered-by mt-5">Powered by</div>
      <div class="abacus-logo"></div>
    </div>
    <div class="col-6 d-flex justify-content-center">
      <div class="form-container shadow-lg" style="border-radius: 13px; width: 70%">

         <register :full-screen="true" />
      </div>
    </div>
  </div>
  </div>
</template>

<script>

import "vue-date-pick/dist/vueDatePick.css";
import Register from "@/components/user/register";
import {mapGetters} from "vuex";

export default {
  components: {
    Register
  },
  mounted() {
    if (!this.isBranded()) {
      const loginFlagEnabled = this.viewConfig.LogIn
      if(!loginFlagEnabled) {
        this.$router.back()
      }
    }
  },
  computed: {
    ...mapGetters(["desktopStyles", "hqDoc", "currentStoreDoc", "getStoreWalletDoc", "getStoreColor", "viewConfig"]),
    hqLogo() {
      if (this.hqDoc && this.hqDoc.Logo !== "") {
        return [
          {
            'background-image': `url(${this.hqDoc.Logo})`
          }
        ];
      }

      return "";
    },
    backgroundColor() {
      let styles = [];
      let colour = this.getStoreColor;

      styles.push({ "background-color": `${colour}` });
      return styles;
    },
    storeThemeConfiguration(){
      if(!this.getStoreWalletDoc || !this.getStoreWalletDoc.ThemeConfiguration){
        return null
      }

      return this.getStoreWalletDoc.ThemeConfiguration
    },

  },
};
</script>
